
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/quizzes-index/jst/NoQuizzesView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"ig-header\">\n  <h2 class=\"ig-header-title\">\n    <i class=\"icon-mini-arrow-down\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.no_quizzes_view")
  },data:data},helper ? helper.call(depth0, "quizzes.no_quizzes_view.headers.course_quizzes", "Course Quizzes", options) : helperMissing.call(depth0, "t", "quizzes.no_quizzes_view.headers.course_quizzes", "Course Quizzes", options)))
    + "\n  </h2>\n</div>\n\n<ul class=\"ig-list\">\n  <li>\n    <div class=\"ig-row ig-row-empty\">\n      <div class=\"ig-empty-msg\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.no_quizzes_view")
  },data:data},helper ? helper.call(depth0, "quizzes.no_quizzes_view.no_quizzes", "No quizzes available", options) : helperMissing.call(depth0, "t", "quizzes.no_quizzes_view.no_quizzes", "No quizzes available", options)))
    + "\n      </div>\n    </div>\n  </li>\n</ul>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  